// extracted by mini-css-extract-plugin
module.exports = {"dialog":"CustomModal_dialog__-o9Em","modal-header":"CustomModal_modal-header__1vm6i","modal-body":"CustomModal_modal-body__3PkvE","modal-footer":"CustomModal_modal-footer__3hC3k"};